export const MIN_LENGTH = 10;
export const MAX_LENGTH = 1000;
